const ExecutionResultKeys = {
  ASSOCIATED_EXECUTION_STATE: 'associatedExecutionState',
  ERROR_TYPE: 'errorType',
  ERROR_SUB_TYPE: 'errorSubType',
  ENTITY_ID: 'entityId',
  ENTITY_TYPE: 'entityType',
  CONTEXT_MAP: 'contextMap'
};
export default ExecutionResultKeys;